(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallPurposeDeleteController',PhoneCallPurposeDeleteController);

    PhoneCallPurposeDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCallPurpose'];

    function PhoneCallPurposeDeleteController($uibModalInstance, entity, PhoneCallPurpose) {
        var vm = this;

        vm.phoneCallPurpose = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCallPurpose.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
